import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReplaySubject, of } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { User } from 'src/typings';
import { DocumentQueueService } from './document-queue.service';

@Component({
  selector: 'app-document-queue-shortcut',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <a *ngIf="view$ | async as view" mat-stroked-button class="documentQueue"
       routerLink="/docs/document-receiving/review" routerLinkActive="documentQueue--active"
       aria-keyshortcuts="Control+Alt+6" [matTooltip]="view.label" [attr.aria-label]="view.label">
      <mat-icon [matBadge]="view.badge" [matBadgeHidden]="view.count === 0"
                matBadgeColor="warn" matBadgeSize="small" aria-hidden="true">find_in_page</mat-icon>
      <span class="cdk-visually-hidden" aria-live="polite">{{ view.label }}</span>
    </a>
  `,
  styles: [`
    :host { display: contents; }
    .documentQueue {
      display: inline-flex; align-items: center; justify-content: center;
      flex: 0 0 46px; width: 46px; min-width: 46px; height: 46px; padding: 0;
      border-radius: 14px; color: #6d28d9; background: #faf5ff; border-color: #c4b5fd;
    }
    .documentQueue:hover, .documentQueue--active { background: #ede9fe; border-color: #8b5cf6; }
    .documentQueue mat-icon { margin: 0; }
  `]
})
export class DocumentQueueShortcutComponent {
  private readonly users = new ReplaySubject<User | undefined>(1);
  @Input() set user(value: User | undefined) { this.users.next(value); }

  readonly view$ = this.users.pipe(
    map((user) => {
      const allowed = user?.isActive !== false && user?.roles?.some((role) =>
        [role.description, role.normalize_description].some((value) =>
          ['user', 'admin'].includes(String(value || '').trim().toLowerCase())));
      return user && allowed ? user.id : null;
    }),
    distinctUntilChanged(),
    switchMap((userId) => userId ? this.queue.watch().pipe(map((state) => ({
      ...state,
      badge: state.unavailable ? '?' : state.count === null ? '…' : state.count > 99 ? '99+' : state.count,
      label: `Сканы на разборе на всех складах: ${state.unavailable
        ? 'счётчик недоступен' : state.count === null ? 'загрузка' : state.count} · Ctrl+Alt+6`
    }))) : of(null))
  );

  constructor(private readonly queue: DocumentQueueService) {}
}
